export default class SmoothScroll {
    constructor(el) {
        this.DOM = { el: el };
        this.DOM.container = this.DOM.el.dataset.scollContainer ? document.querySelector(this.DOM.el.dataset.scollContainer) : window;
        this.DOM.target = document.querySelector(this.DOM.el.getAttribute('href'));
        this.DOM.mainHeader = document.querySelector('#main-header');

        this.initEvents();
    }

    initEvents() {
        /* Add event listener */
        this.DOM.el.addEventListener('click', (e) => {
            e.preventDefault();

            this.DOM.container.scroll({
                top: this.DOM.target.offsetTop - this.DOM.mainHeader.clientHeight,
                left: 0,
                behavior: 'smooth',
            });
        });
    }
}

const smoothScrollNodes = Array.from(document.querySelectorAll('[data-smooth-scroll]'));
if (smoothScrollNodes !== null) {
    smoothScrollNodes.forEach((node) => { new SmoothScroll(node); });
}
